// extracted by mini-css-extract-plugin
export default {"wrapper":"Jy-z","viewport":"Ky-z","container":"Ly-z","slide":"My-z"};